// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Oh-z","title":"Ph-z","nav":"Qh-z","flexCell":"Rh-z","facetLink":"Sh-z"};